import TextBoxV2 from "../../forms/inputs/TextBoxV2";
import { InputBaseParams } from "../../forms/Form";
import { useState } from "react";

const SettingsTextBoxV2 = ({
  name,
  label,
  password,
  placeholder,
  rules,
  className,
  withVisibilityToggle
}: InputBaseParams & {
  password?: boolean;
  placeholder?: string;
  label?: string;
  className?: string;
  withVisibilityToggle?: boolean;
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const showToggle = !!withVisibilityToggle && !!password;
  const inputPassword = password ? !isVisible : false;

  return (
    <div className={`${className ? className : "w-full"}`}>
      {label && (
        <p className="mb-2">
          {label}{" "}
          {rules?.required ? <span className="text-ctb-red-500">*</span> : <></>}
        </p>
      )}
      <div className={`relative`}>
        <TextBoxV2
          name={name}
          placeholder={placeholder}
          rules={rules}
          className={`mb-4 w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-base shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 ${showToggle ? "pr-10" : ""}`}
          errorClassName="!border-red-500"
          password={inputPassword}
        />
        {showToggle && (
          <button
            type="button"
            aria-label={isVisible ? "Hide password" : "Show password"}
            onClick={() => setIsVisible(v => !v)}
            className="absolute right-2 top-1/2 -translate-y-[90%] text-gray-600 hover:text-gray-800"
          >
            <svg className="w-4 h-4 block" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {isVisible ? (
                <>
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                  <circle cx="12" cy="12" r="3" />
                </>
              ) : (
                <>
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.77 21.77 0 0 1 5.06-5.94" />
                  <path d="M9.9 4.24A10.94 10.94 0 0 1 12 5c7 0 11 7 11 7a21.77 21.77 0 0 1-3.17 4.09" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </>
              )}
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default SettingsTextBoxV2;
